export enum ClientsAffectedEnum {
    NO_DATA,
    FROM_1_TO_20000,
    FROM_20001_TO_100000,
    FROM_100001_TO_1000000,
    MORE_THAN_1000000,
}
